import { DomainError } from './DomainError';

export class ValidationError extends DomainError {
    data = {};

    /**
     *
     * @param message
     * @param data
     */
    constructor(message, data = {}) {
        super(message, data);
        this.data = data;
    }

    toString() {
        return this.message;
    }
}
